// extracted by mini-css-extract-plugin
export default {"qrCode":"index_qrCode_ve4O2","closeBtn":"index_closeBtn_LfCQd"};